import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';

export interface BackActionProps {
  to: string;
  label: string;
  onClick?: () => void;
}

/**
 * Component that renders a back navigation button with an arrow icon
 * @param to - Path to navigate to.
 * @param label - Label text.
 * @param onClick - Optional custom click handler. If provided, overrides default navigation
 */
const BackAction: React.FC<BackActionProps> = ({ to, label, onClick }) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      history.push(to);
    }
  };

  return (
    <Button
      type="link"
      size="small"
      onClick={handleClick}
      className="btn-back"
      icon={<ArrowLeftOutlined className="text-sm" />}
    >
      {label}
    </Button>
  );
};

export default BackAction;
